import React from 'react'
import profile from '../../../assets/images/logo.png'
import myPhoto from '../../../assets/images/samuel.jpg'
import SocialLinks from '../../../components/SocialLinks'

const Profile = () => {

    return (
        <div className='lg:w-[380px] border-[1px] border-[#575756] rounded-3xl px-6 py-10 sticky top-16'>
            <div className='flex justify-between mb-6 gap-2'>
                <h2 className='text-white text-4xl font-bold'>Samuel</h2>
                <h2 className='text-white leading-[20px] text-right'>Web & Mobile app developer</h2>
            </div>
            {/* <p className='text-center text-[8rem]'>👨🏽‍💻</p> */}
            <div className='relative group overflow-hidden w-fit mx-auto'>
                {/* Main image */}
                <img src={myPhoto} alt="" className="h-[250px] w-[250px] object-cover rounded-3xl mx-auto relative z-10 brightness-75 saturate-150" />
                
                {/* Two major glitch bars */}
                <img src={myPhoto} alt="" className="absolute inset-0 h-[250px] w-[250px] object-cover rounded-3xl mx-auto z-20 opacity-70 mix-blend-luminosity border border-green-400" 
                    style={{ 
                        clipPath: 'polygon(0 100%, 100% 100%, 100% 28%, 0 98%)',
                        filter: 'hue-rotate(90deg) contrast(150%)'
                    }}
                />
                {/* <img src={myPhoto} alt="" className="absolute inset-0 h-[250px] w-[250px] object-cover rounded-3xl mx-auto z-20 animate-glitch-2 opacity-70 mix-blend-screen" 
                    style={{ 
                        clipPath: 'polygon(0 52%, 100% 52%, 100% 70%, 0 70%)',
                        filter: 'hue-rotate(180deg) contrast(150%)'
                    }}
                /> */}
            </div>
            <div className='flex flex-col items-center'>
                <h2 className='text-white text-lg text-white mt-8'>samuelakinboro7@gmail.com</h2>
                <h2 className='text-white text-lg text-white mt-2 mb-6'>Lagos, Nigeria</h2>

                {/* SOCIAL MEDIA ICONS */}
                <SocialLinks />
                <a href='#contact'>
                    <button className='btn btn-wide btn-primary mt-8 rounded-3xl'>Hire Me</button>
                </a>
            </div>
        </div>
    )
}

export default Profile